import { OFFER_CONDITION_NAMES_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { IOfferConditionName } from "../../shared/interfaces/offer/IOfferConditionName";

export const OfferConditionNameService = {
  getAll: (params: IPagination) => requests.get(OFFER_CONDITION_NAMES_URL, params),
  create: (params: IOfferConditionName) =>
    requests.post(`${OFFER_CONDITION_NAMES_URL}`, params),
  getSingle: (id: number) => requests.get(`${OFFER_CONDITION_NAMES_URL}/${id}`),
  update: (params: IOfferConditionName, id: number) =>
    requests.put(`${OFFER_CONDITION_NAMES_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${OFFER_CONDITION_NAMES_URL}/${id}`),
  sort: (ids: (number | string)[]) =>
    requests.patch(`${OFFER_CONDITION_NAMES_URL}/sort`, { ids }),
};
